/**
 * Presentational deal-type + property-type + sort controls using the
 * `.profile-filters*` vocabulary. Prop-driven only — no fetch, no Redux,
 * no owner status/lifecycle filters.
 *
 * Layout (Issue #183): deal-type stays in `__main`; property-type + sort
 * share one wrapping `__utility-row` with sort pushed right via
 * `margin-left: auto`.
 */

import {
  PROFILE_DEAL_TYPES,
  PROFILE_DEFAULT_DEAL_TYPE,
  PROFILE_DEFAULT_SORT,
  PROFILE_PROPERTY_TYPES,
  PROFILE_SORT_OPTIONS,
  normalizeProfileDealType,
  normalizeProfileSort,
} from "../lib/profilePropertyTypes";

function ProfileTypeSortFilters({
  extraMainFields = null,
  dealType = PROFILE_DEFAULT_DEAL_TYPE,
  onDealTypeChange,
  typeSet,
  onToggleType,
  sort = PROFILE_DEFAULT_SORT,
  onSortChange,
  sortSelectId = "profile-sort",
  typeInputName = "profile-type",
  dealInputName = "profile-deal-type",
}) {
  const normalizedDeal = normalizeProfileDealType(dealType);
  const normalizedSort = normalizeProfileSort(sort);

  return (
    <>
      <div className="profile-filters__main">
        {extraMainFields}

        <div className="profile-filters__field">
          <span className="profile-filters__label">Тип угоди</span>
          <div
            className="profile-filters__segmented"
            role="radiogroup"
            aria-label="Тип угоди"
          >
            {PROFILE_DEAL_TYPES.map((opt) => {
              const selected = normalizedDeal === opt.value;
              return (
                <label key={opt.value || "all"} className="profile-filters__seg">
                  <input
                    type="radio"
                    name={dealInputName}
                    value={opt.value}
                    checked={selected}
                    onChange={() => onDealTypeChange(opt.value)}
                  />
                  <span>{opt.label}</span>
                </label>
              );
            })}
          </div>
        </div>
      </div>

      <div className="profile-filters__utility-row">
        <div className="profile-filters__field profile-filters__type-field">
          <span className="profile-filters__label">Тип нерухомості</span>
          <div
            className="profile-filters__chips"
            role="group"
            aria-label="Тип нерухомості"
          >
            {PROFILE_PROPERTY_TYPES.map((opt) => {
              const on = typeSet.has(opt.value);
              return (
                <label key={opt.value} className="profile-filters__chip">
                  <input
                    type="checkbox"
                    name={typeInputName}
                    value={opt.value}
                    checked={on}
                    onChange={() => onToggleType(opt.value)}
                  />
                  <i className={opt.icon} aria-hidden="true" />
                  <span>{opt.label}</span>
                </label>
              );
            })}
          </div>
        </div>

        <div className="profile-filters__sort">
          <label className="profile-filters__field" htmlFor={sortSelectId}>
            <span className="profile-filters__label">Сортувати</span>
            <div className="profile-filters__select-wrap">
              <i className="fa-solid fa-arrow-down-wide-short" aria-hidden="true" />
              <select
                className="profile-filters__select"
                id={sortSelectId}
                value={normalizedSort}
                onChange={(event) => onSortChange(event.target.value)}
              >
                {PROFILE_SORT_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </label>
        </div>
      </div>
    </>
  );
}

export default ProfileTypeSortFilters;
